import { IOrder, IOrderItem } from '@/interfaces/order';
import {
  convertNumberToThaiText,
  formatThaiDate,
  formatNumber,
} from '@/utils/dataUtils';
import { round } from 'lodash';
import React from 'react';
import TemplateOrderInfoItemProductQr from './template-order-info-product-qr';

interface IProps {
  items?: Partial<IOrderItem>[];
  data: IOrder;
  isShowPrice?: boolean;
  isShowPackage?: boolean;
  isShowShiptoRemark?: boolean;
  isShowTotal?: boolean;
  isProductQrcode?: boolean;
}

const TemplateOrderInfoItem = ({
  data,
  isShowPrice,
  isShowPackage,
  isShowShiptoRemark,
  isShowTotal = true,
  items,
  isProductQrcode = false,
}: IProps) => {
  console.log(data.orderItems);
  return (
    <>
      <div className="flex w-full text-xs mt-2">
        <table
          border={1}
          cellSpacing={0}
          cellPadding={5}
          style={{
            width: '100%',
            border: '0.5px; black solid',
            borderCollapse: 'collapse',
          }}
        >
          <tr>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={5}
            >
              <strong>
                ลำดับ <br /> Line No.
              </strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={100}
            >
              <strong>
                รหัสสินค้า <br /> Item Code
              </strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
            >
              <strong>
                รายการสินค้า <br /> Item Description
              </strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
              width={60}
            >
              <strong>
                เลขที่ผลิต <br /> Lot no.
              </strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
            >
              <strong>
                จำนวน <br /> Quantity
              </strong>
            </td>
            <td
              style={{
                border: '1px solid black',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
            >
              <strong>
                หน่วย <br />
                Unit
              </strong>
            </td>
            {isShowPrice && (
              <>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                    verticalAlign: 'middle',
                  }}
                  width={81}
                >
                  <strong>
                    ราคาต่อหน่วย <br />
                    Unit Price
                  </strong>
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                    verticalAlign: 'middle',
                  }}
                  width={115}
                >
                  <strong>
                    ราคาขายไม่รวม VAT <br />
                    Price Exclude VAT
                  </strong>
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                    verticalAlign: 'middle',
                  }}
                  width={20}
                >
                  <strong>
                    VAT <br />
                    (%)
                  </strong>
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                    verticalAlign: 'middle',
                  }}
                  width={30}
                >
                  <strong>
                    จำนวนเงิน (บาท) <br />
                    Amount(Baht)
                  </strong>
                </td>
              </>
            )}
            {isShowPackage && (
              <>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                    verticalAlign: 'middle',
                  }}
                >
                  <strong>
                    จำนวน <br /> Package <br /> Quantity
                  </strong>
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                    verticalAlign: 'middle',
                  }}
                >
                  <strong>
                    หน่วย
                    <br /> Package
                    <br />
                    Unit
                  </strong>
                </td>
              </>
            )}
          </tr>
          {items?.map((i, idx) => {
            const vatRate = round(
              Number(i.totalPrice) * (data.vatRate / 100),
              2,
            );
            // const beforeVat = round(Number(i.totalPrice) - vatRate, 2);
            return (
              <tr key={i.id}>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                  }}
                >
                  {idx + 1}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                  }}
                >
                  {i.productCode}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                  }}
                >
                  {i.productName}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                  }}
                >
                  {i.lotNumber}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                  }}
                >
                  {formatNumber(Number(i.quantity), 2)}
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'center',
                  }}
                >
                  {i.baseUnitName}
                </td>
                {isShowPrice && (
                  <>
                    <td
                      style={{
                        border: '1px solid black',
                        textAlign: 'center',
                      }}
                    >
                      {formatNumber(Number(i.unitPrice), 2)}
                    </td>
                    <td
                      style={{
                        border: '1px solid black',
                        textAlign: 'right',
                      }}
                    >
                      {formatNumber(Number(i.totalPrice || 0), 2)}
                    </td>
                    <td
                      style={{
                        border: '1px solid black',
                        textAlign: 'right',
                      }}
                    >
                      {(data.vatRate && `${data.vatRate || 0}%`) || '-'}
                    </td>

                    <td
                      style={{
                        border: '1px solid black',
                        textAlign: 'right',
                      }}
                    >
                      {formatNumber(Number(i.totalPrice || 0) + vatRate, 2)}
                    </td>
                  </>
                )}
                {isShowPackage && (
                  <>
                    <td
                      style={{
                        border: '1px solid black',
                        textAlign: 'center',
                      }}
                    >
                      {formatNumber(
                        Number((i.quantity || 0) / (i.conversion || 0)),
                        2,
                      )}
                    </td>
                    <td
                      style={{
                        border: '1px solid black',
                        textAlign: 'center',
                      }}
                    >
                      {i.packageUnitName}
                    </td>
                  </>
                )}
              </tr>
            );
          })}

          {isShowPrice && isShowTotal && (
            <>
              <tr>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                  }}
                  colSpan={6}
                >
                  <strong>ราคารวม</strong>
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                  }}
                  colSpan={4}
                >
                  <strong> {formatNumber(Number(data?.totalAmount), 2)}</strong>
                </td>
              </tr>
              {!!data?.discountAmount && (
                <>
                  <tr>
                    <td
                      style={{
                        border: '1px solid black',
                        textAlign: 'right',
                      }}
                      colSpan={6}
                    >
                      <strong>ส่วนลดท้ายบิล</strong>
                    </td>
                    <td
                      style={{
                        border: '1px solid black',
                        textAlign: 'right',
                      }}
                      colSpan={4}
                    >
                      <strong>
                        {' '}
                        {formatNumber(Number(data?.discountAmount), 2)}
                      </strong>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style={{
                        border: '1px solid black',
                        textAlign: 'right',
                      }}
                      colSpan={6}
                    >
                      <strong>ราคาหลังหักส่วนลด</strong>
                    </td>
                    <td
                      style={{
                        border: '1px solid black',
                        textAlign: 'right',
                      }}
                      colSpan={4}
                    >
                      <strong>
                        {' '}
                        {formatNumber(
                          Number(data?.totalAmount) -
                            Number(data?.discountAmount),
                          2,
                        )}
                      </strong>
                    </td>
                  </tr>
                </>
              )}
              <tr>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                  }}
                  colSpan={6}
                >
                  <strong>ภาษีมูลค่าเพิ่ม VAT</strong>
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                  }}
                  colSpan={4}
                >
                  <strong> {formatNumber(Number(data?.vatAmount), 2)}</strong>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                  }}
                  colSpan={6}
                >
                  <strong>รวมเงินทั้งสิ้น Net Total</strong>
                </td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                  }}
                  colSpan={4}
                >
                  <strong> {formatNumber(Number(data?.summary), 2)}</strong>
                </td>
              </tr>
              <tr>
                <td colSpan={6}></td>
                <td
                  style={{
                    border: '1px solid black',
                    textAlign: 'right',
                  }}
                  colSpan={4}
                >
                  <strong>
                    {convertNumberToThaiText(Number(data?.summary))}
                  </strong>
                </td>
              </tr>
            </>
          )}
        </table>
      </div>
      {data?.postponeRemark && (
        <div className="mt-3" style={{ fontSize: 10 }}>
          <p>
            {`วันที่ในเอกสาร (${formatThaiDate(data.orderCreateDate)}) อาจคลาดเคลื่อนจากวันที่ส่งจริง (${formatThaiDate(data.orderDate)}) ทั้งนี้วันครบกำหนดชำระจะนับจากวันที่ทำการจัดส่งสินค้า เนื่องจาก ${data?.postponeRemark || ''}`}
          </p>
        </div>
      )}
      {isShowShiptoRemark && (
        <div className="text-bold mt-3">
          <strong>หมายเหตุขนส่ง : </strong>
          <p>
            ส่งสินค้าภายใน {(data?.dueDateTime as string) || '-'} น.{' '}
            {data?.shipToRemark}
          </p>
        </div>
      )}
      {isProductQrcode && !!data?.customer?.isProductQrCode && (
        <TemplateOrderInfoItemProductQr data={data} />
      )}
    </>
  );
};

export default TemplateOrderInfoItem;
